import { render, staticRenderFns } from "./TableRowNumTestsPerPhysician.vue?vue&type=template&id=16f25a34&lang=pug&"
import script from "./TableRowNumTestsPerPhysician.vue?vue&type=script&lang=js&"
export * from "./TableRowNumTestsPerPhysician.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f25a34')) {
      api.createRecord('16f25a34', component.options)
    } else {
      api.reload('16f25a34', component.options)
    }
    module.hot.accept("./TableRowNumTestsPerPhysician.vue?vue&type=template&id=16f25a34&lang=pug&", function () {
      api.rerender('16f25a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/tracking-sheet/table-rows/TableRowNumTestsPerPhysician.vue"
export default component.exports